import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import FireOutlinedSvg from "@ant-design/icons-svg/es/asn/FireOutlined";
import AntdIcon from "../components/AntdIcon";
var FireOutlined = function FireOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FireOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  FireOutlined.displayName = 'FireOutlined';
}
export default /*#__PURE__*/React.forwardRef(FireOutlined);